import globals from '@/translations/fr/components/globals';
import layout from '@/translations/fr/components/layout';
import accessmaster from '@/translations/fr/components/accessmaster';
import patient from '@/translations/fr/components/patient';
import project from '@/translations/fr/components/project';
import importer from '@/translations/fr/components/importer';
import controlResult from '@/translations/fr/components/controlResult';
import patientExperienceSurvey from '@/translations/fr/components/patientExperienceSurvey';
import surveyCampaign from '@/translations/fr/components/surveyCampaign';
import controleFile from '@/translations/fr/components/controleFile';
export default {
	globals,
	layout,
	accessmaster,
	patient,
	project,
	importer,
	controlResult,
	patientExperienceSurvey,
	surveyCampaign,
	controleFile
};
